const baseApiUrl = process.env.VUE_APP_MAIN_DOMAIN_URL;

export class ShopAuthError extends Error {
  constructor(status) {
    super(status === 403 ? "Access denied" : "Open the shop from Telegram");
    this.status = status;
  }
}

const shopFetch = async (url, options) => {
  const initData = window.Telegram?.WebApp?.initData;
  if (!initData) {
    window.dispatchEvent(new CustomEvent("shop-auth-error", { detail: 401 }));
    throw new ShopAuthError(401);
  }
  const response = await fetch(url, {
    ...options,
    headers: { ...options.headers, Authorization: `Telegram ${initData}` },
  });
  if (response.status === 401 || response.status === 403) {
    window.dispatchEvent(new CustomEvent("shop-auth-error", { detail: response.status }));
    throw new ShopAuthError(response.status);
  }
  const result = await response.json();
  if (!response.ok) {
    const error = new Error(result.message || result.error || "Shop request failed");
    error.status = response.status;
    error.details = result;
    throw error;
  }
  return result;
};

export const GET_CUSTOMER_INFORMATION = async (id) => {
  return shopFetch(
    `${baseApiUrl}/api/v1/shop/customer?customer_id=${id}`,
    {
      method: "GET",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
};

export const GET_ALL_PRODUCTS = async (id) => {
  return shopFetch(
    `${baseApiUrl}/api/v1/shop/products/get?customer_id=${id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
};

export const GET_ONE_PRODUCT = async (product) => {
  return shopFetch(
    `${baseApiUrl}/api/v1/shop/products/${product}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
};

export const GET_CITYS = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/order/city`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const GET_ORDER_BRANCH = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/order/branch`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const SET_ORDER_BRANCH_SAVE = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/order/save`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const GET_COME_TO_PAY = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/order/pay`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const GET_ORDER_PAYMENT = async (orderId) =>
  shopFetch(`${baseApiUrl}/api/v1/shop/order/payment?order_id=${encodeURIComponent(orderId)}`, {
    method: "GET",
    headers: { Accept: "application/json", "Cache-Control": "no-cache" },
    cache: "no-store",
  });

export const GET_MY_ORDERS = async (page = 1) =>
  shopFetch(`${baseApiUrl}/api/v1/shop/orders?page=${encodeURIComponent(page)}`, {
    method: "GET", cache: "no-store", headers: { Accept: "application/json" },
  });

export const GET_MY_ORDER = async (orderId) =>
  shopFetch(`${baseApiUrl}/api/v1/shop/orders/${encodeURIComponent(orderId)}`, {
    method: "GET", cache: "no-store", headers: { Accept: "application/json" },
  });

export const GET_ORDER_CART = async (id) => {
  return shopFetch(
    `${baseApiUrl}/api/v1/shop/cart/get?customer_id=${id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
      },
    }
  );
};

export const GET_ADD_TO_CART = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/cart/add`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const GET_ADD_COUNTER_CART = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/cart/plus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const GET_MINUS_COUNTER_CART = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/cart/minus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};

export const GET_DELETE_CART = async (data) => {
  return shopFetch(`${baseApiUrl}/api/v1/shop/cart/delete`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
};
